/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Thumbnail_Prompt_NoInputs */

const en_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, skip`)
};

const fr_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non, passez votre chemin`)
};

const de_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein, überspringen.`)
};

const it_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, salta`)
};

const ru_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет, пропустить`)
};

const es_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, salta`)
};

const zh_cn2_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不，跳过`)
};

const ja_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ、スキップ`)
};

const hi_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं, छोड़ दो`)
};

const pt_pt2_scene_change_detection_thumbnail_prompt_no = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, pule`)
};

/**
* | output |
* | --- |
* | "No, skip" |
*
* @param {Scene_Change_Detection_Thumbnail_Prompt_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_prompt_no = /** @type {((inputs?: Scene_Change_Detection_Thumbnail_Prompt_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Prompt_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "de") return de_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "it") return it_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "ru") return ru_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "es") return es_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "ja") return ja_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "hi") return hi_scene_change_detection_thumbnail_prompt_no(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_thumbnail_prompt_no(inputs)
	return en_scene_change_detection_thumbnail_prompt_no(inputs)
});